<template>
    <div>
        <v-dialog v-model="showBackgroundColorPicker">
            <v-card tile>
                <v-toolbar card dark color="primary">
                    <v-toolbar-title>Hoofdkleur</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="showBackgroundColorPicker = false">Opslaan</v-btn>
                </v-toolbar>
                <color-picker :value="backgroundColor" @input="updateBackgroundColor" />
            </v-card>
        </v-dialog>
        <v-dialog v-model="showAccentColorPicker">
            <v-card tile>
                <v-toolbar card dark color="accent">
                    <v-toolbar-title>Accentkleur</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="showAccentColorPicker = false">Opslaan</v-btn>
                </v-toolbar>
                <color-picker :value="accentColor" @input="updateAccentColor" />
            </v-card>
        </v-dialog>
        <v-card>
            <v-toolbar card dark color="primary">
                <v-toolbar-title>Instellingen</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="$emit('close')">Sluiten</v-btn>
            </v-toolbar>
            <v-card-text>
                <form>
                    <v-layout align-center justify-center>
                    <v-img v-if="clientLogo"
                            :contain="true"
                            max-height="80"
                            max-width="300"
                            :src="clientLogo"
                    >
                        <template slot="placeholder">
                            <v-layout fill-height align-center justify-center ma-0>
                                <v-progress-circular indeterminate
                                                        color="grey lighten-5"></v-progress-circular>
                            </v-layout>
                        </template>
                    </v-img>
                    </v-layout>
                    <!-- <v-text-field
                        label="Logo"
                        v-model="clientLogo"
                        @change="updateLogo" /> -->
                    <v-btn block @click="$refs.inputUpload.click()">
                        Selecteer een afbeelding
                    </v-btn>
                    <p class="caption grey--text">Deze afbeelding wordt niet verzonden of opgeslagen</p>
                    <input ref="inputUpload"
                            type="file"
                            id="logo-upload"
                            accept="image/*"
                            @change="loadLogo">

                    <v-text-field
                            label="Hoofdkleur"
                            :value="backgroundColor"
                            @input="updateBackgroundColor">
                        <div class="colorPreview" slot="prepend" @click="showBackgroundColorPicker = true"
                                :style="{backgroundColor: backgroundColor}"></div>

                        <v-btn icon @click="colorSwap" slot="append-outer">
                            <v-icon>cached</v-icon>
                        </v-btn>
                    </v-text-field>

                    <v-text-field label="Accentkleur"
                                    :value="accentColor"
                                    @input="updateAccentColor">
                        <div class="colorPreview" slot="prepend" @click="showAccentColorPicker = true"
                                :style="{backgroundColor: accentColor}"></div>

                        <v-btn icon @click="colorSwap" slot="append-outer">
                            <v-icon>cached</v-icon>
                        </v-btn>
                    </v-text-field>
                    <v-switch v-model="dark"
                                @change="themeSwitched"
                                :label="theme"
                    ></v-switch>
                </form>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import { Chrome } from 'vue-color'

export default {
    components: {
        colorPicker: Chrome,
    },
    data () {
        return {
            showBackgroundColorPicker: false,
            showAccentColorPicker: false,
            dark: null,
            backgroundColor: '#000000',
            accentColor: '#000000',
            clientLogo: null,
        }
    },
    computed: {
        theme () {
            return this.dark ? 'dark' : 'light'
        },
    },
    methods: {
        updateAccentColor (value) {
            if (value.hex) {
                this.$store.commit('accentColorUpdated', value.hex)
                this.accentColor = value.hex
            } else {
                this.$store.commit('accentColorUpdated', value)
                this.accentColor = value
            }
        },
        updateBackgroundColor (value) {
            if (value.hex) {
                this.$store.commit('backgroundColorUpdated', value.hex)
                this.backgroundColor = value.hex
            } else {
                this.$store.commit('backgroundColorUpdated', value)
                this.backgroundColor = value
            }
        },
        updateLogo () {
            this.$store.commit('logoUpdated', this.clientLogo)
        },
        loadLogo () {
            let files = document.querySelector('#logo-upload').files

            if (files && files[ 0 ]) {
                let reader = new FileReader()
                reader.onload = (e) => {
                    this.clientLogo = e.target.result
                    this.updateLogo()
                }
                reader.readAsDataURL(files[ 0 ])
            }
        },
        themeSwitched () {
            this.$store.commit('setDarkTheme', this.dark)
        },
        colorSwap () {
            let swap = this.accentColor
            this.accentColor = this.backgroundColor
            this.backgroundColor = swap
            this.$store.commit('backgroundColorUpdated', this.backgroundColor)
            this.$store.commit('accentColorUpdated', this.accentColor)
        },
    },
    mounted () {
        this.dark = this.$store.getters.darkTheme
        this.backgroundColor = this.$store.getters.backgroundColor
        this.accentColor = this.$store.getters.accentColor
        this.clientLogo = this.$store.getters.logo
    },
}
</script>

<style lang="scss">
    .v-dialog__content {
        .v-dialog {
            position: relative;
        }
    }

    .colorPreview {
        display: block;
        width: 35px;
        height: 35px;
        border-radius: 50%;
    }

    #logo-upload {
        display: none;
    }

    .vc-chrome {
        width: 100% !important;
    }
</style>
